import { type InferType } from "yup";
import { SepaAccountDetailsInputSchema } from "./AccountDetails/constants";
import { SepaBankDetailsInputSchema } from "./BankDetails/constants";

export const SepaPaymentPrefInputSchema = SepaBankDetailsInputSchema.concat(
  SepaAccountDetailsInputSchema,
);

export type SepaPaymentPrefInputType = InferType<typeof SepaPaymentPrefInputSchema>;
